import Styled from "styled-components";

export interface PitchProps {
  $fullWidth?: boolean;
}

export const Container = Styled.div`
  padding: 2rem 0;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 4.6875rem 0;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 5.625rem 0;
  }
`;

export const Content = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;
  gap: 1rem;
  
  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
    gap: 1.875rem;
  }
`;

export const Pitch = Styled.div<PitchProps>`
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.562rem;
  letter-spacing: -0.2px;
  text-align: center;
  max-width: 17.8125rem;

  & > p {
    margin: 1rem 0;
  }

  & > p:first-child {
    margin-top: 0;
  }

  & > p:last-child {
    margin-bottom: 0;
  }

  ${(props) =>
    props.$fullWidth &&
    `
      max-width: 100%;
  `}

  ${(props) => props.theme.breakpoints.up("large")} {
    font-size: 1.624rem;
    line-height: 2rem;
  }

`;
